import "@hotwired/turbo-rails"
import "trix"
import "@rails/actiontext"
import "leaflet"
import "leaflet-fullscreen"
import "lightgallery/css/lightgallery.css"
import "../../assets/tailwind/application.css";
import "../../assets/stylesheets/actiontext.scss";

import * as ActiveStorage from "@rails/activestorage"

ActiveStorage.start()


import "../controllers"

Trix.config.blockAttributes.default.tagName = "p"
Trix.config.blockAttributes.default.breakOnReturn = true

